<template>
  <div id="listWidget" class="mb-4">
    <div class="instruction-card card-item mb-2">
      <div class="instruction-header">
        <i class="fa-solid fa-info-circle me-2 text-primary"></i>
        <span class="instruction-title">전동블라인드 등록 완료</span>
      </div>
      <div class="instruction-body">
        <p class="mb-0" style="font-size: 0.85rem; line-height: 1.6; color: #495057;">
          전동블라인드 등록이 완료되었습니다.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col" />
      <div class="col" />
      <div class="col">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          style="width: 100%"
          @click="onRegistCompleteClick"
        >
          완료
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const router = useRouter();

onMounted(async () => {
  await store.dispatch('home/fetchAllZones');
});

const onRegistCompleteClick = () => {
  router.go(-1);
};
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}
</style>
